import { leftPad } from './leftPad';

export const createArrayOfMonths = (year: string) => {
  let arr = Array.from({ length: 12 }, (_, i) => '01.' + leftPad(i + 1, 2, '0') + `.${year}`);
  return arr;
};
